import React from 'react'
import { isEmpty, pathOr, compose, map } from 'ramda'
import { useFetch, useForm } from '../../../../hooks'
import { getResponseData } from '../../../../helpers'
import Button from '../../../../components/inputs/Button'
import Buttons from '../../../../modules/Buttons'
import { StyledForm, StyledSteps, StyledStepsHeader, StyledStepsItem, StyledStepName, StyledStepDesc, StyledFormSelectWrapper, StyledStepImage } from './styled'
import FromSelect from '../../../../components/inputs/FromSelect';
import { toast } from 'react-toastify'

const FormAddSensor = ({ zoneid, url, urlModal, cbFetch, onClickCancel }) => {

    const { response } = useFetch({
        url: `/${urlModal}`,
        method: 'GET'
    })

    const { fetching, doFetch } = useFetch({
        url,
        method: 'POST'
    })

    const addSensor = async values => {
        const { sensor } = values;
        const response = await doFetch({
            data: {
                sensor: sensor ? parseInt(sensor, 10) : null,
                zoneid
            }
        })

        const isError = pathOr(false, ['error'], response);
        const message = pathOr(null, ['msg'], response);
        if (isError) {
            message && toast.error(message);
        } else {
            message && toast.success(message);
            cbFetch && cbFetch();
        }
    }

    const { values, errors, handleChange, handleSubmit } = useForm({
        callback: addSensor
    })

    return (
        !isEmpty(response.data) &&
        <StyledForm onSubmit={handleSubmit}>
            <StyledSteps>
                <StyledStepsHeader>
                    {pathOr("", ["title"], getResponseData(response))}
                </StyledStepsHeader>
                <StyledStepsItem>
                    <StyledStepName>
                        {`1. ${pathOr("", ["step1", "title"], getResponseData(response))}`}
                    </StyledStepName>
                    <StyledStepDesc>
                        {pathOr("", ["step1", "info"], getResponseData(response))}
                    </StyledStepDesc>
                    {pathOr(false, ["step1", "icon"], getResponseData(response)) && (
                        <StyledStepImage>
                            <img src={`/${pathOr("", ["step1", "icon"], getResponseData(response))}`} alt="biosensor instruction" />
                        </StyledStepImage>
                    )}
                </StyledStepsItem>
                <StyledStepsItem>
                    <StyledStepName>
                        {`2. ${pathOr("", ["step2", "title"], getResponseData(response))}`}
                    </StyledStepName>
                    <StyledStepDesc>
                        {pathOr("", ["step2", "info"], getResponseData(response))}
                    </StyledStepDesc>
                    <StyledFormSelectWrapper>
                        <FromSelect
                            placeholder={pathOr("", ["step2", "placeholder"], getResponseData(response))}
                            name='sensor'
                            onChange={handleChange}
                            value={values.sensor}
                            error={errors.sensor}
                            options={compose(
                                map(option => ({ value: option, label: option })),
                                pathOr("", ["step2", "data"]),
                                getResponseData
                            )(response)}
                            green
                            noMargin
                        />
                    </StyledFormSelectWrapper>
                    <Buttons>
                        <Button
                            type='button'
                            onClick={onClickCancel}
                            width='50%'
                        >
                            {pathOr("", ["step2", "buttons", "cancel"], getResponseData(response))}
                        </Button>
                        <Button
                            type='submit'
                            green
                            width='50%'
                            disabled={fetching}
                        >
                            {pathOr("", ["step2", "buttons", "save"], getResponseData(response))}
                        </Button>
                    </Buttons>
                </StyledStepsItem>
            </StyledSteps>
        </StyledForm>
    )
}

export default FormAddSensor
